import { CustomerDTO } from "../DTO/customerDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateCustomerRequest extends BasicRequest{
    
    public customer! : CustomerDTO;

    constructor(){
        super();
    }
}